import React from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';
import MobileNavigation from './NavigationMobile';
import useIsMobile from '../Hooks/useIsMobile';

const Navigation = () => {
    const isMobile = useIsMobile();
    const contentLinks = useSelector((state) => state.navigation.contentLinks);
    const navState = useSelector((state) => state.navigation);

    return isMobile
        ? <MobileNavigation {...navState}/>
        : <NavigationItem links={contentLinks} />;
};

export default Navigation;
